// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Radio from 'common/domain/radio';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import GenderReach from 'common/domain/GenderReach';
import PrintingService from 'common/services/PrintingService';
import AntennaReach from 'statsradio/domain/AntennaReach';
import PrintingPage from 'common/components/PrintingPage';

import WeeklyDashboardPrinting from './WeeklyDashboardPrinting';
import MonthlyDashboardPrinting from './MonthlyDashboardPrinting';
import type { DashboardMetrics, MonthlyDashboardData, WeeklyDashboardData } from '../domain/DashboardData';
import { hourlyMetricsType, GeoMapTypes } from '../domain/DashboardData';
import DashboardPrintingDemoGeo from './DashboardPrintingDemoGeo';
import GeolocationReach from '../domain/GeolocationReach';
import PrintingHeader from '../../../../common/modules/printing/components/PrintingHeader';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';

const Wrapper = styled.div`
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  font-size: 12px;

  @page {
    size: letter portrait;
    margin: 2.00cm 0 2.00cm 0;
  }
`;

type State = {
  loaded: boolean;
  metricsData?: WeeklyDashboardData | MonthlyDashboardData;
  from: ?moment;
  to: ?moment;
  monthlySelected: ?boolean;
  type: ?hourlyMetricsType;
  geoMapType: GeoMapTypes;
  radio: ?Radio;
  geoMapData: ?Object;
  centralMarket: ?CentralMarket;
}

class DashboardPrintingPage extends Component<void, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      loaded: false,
      metricsData: undefined,
      geoMapData: undefined,
      from: undefined,
      to: undefined,
      monthlySelected: undefined,
      type: undefined,
      radio: undefined,
      geoMapType: undefined,
      centralMarket: undefined,
    };
  }

  componentWillMount() {
    const dashboardData = PrintingService.getData('DASHBOARD_PRINTING_DATA');

    if (!dashboardData) {
      return;
    }

    const parsedData = this.parseMetrics(dashboardData.data);

    this.setState({
      loaded: true,
      metricsData: parsedData,
      from: dashboardData.from,
      to: dashboardData.to,
      monthlySelected: dashboardData.monthlySelected,
      type: dashboardData.type,
      geoMapType: dashboardData.geoMapType,
      radio: Radio.fromJSON(dashboardData.radio),
      centralMarket: dashboardData.centralMarket && CentralMarket.parse(dashboardData.centralMarket),
      geoMapData: {
        antennas: dashboardData.antennas,
        layout: dashboardData.layout,
        antennaMapViewport: dashboardData.antennaMapViewport,
      },
    }, () => {
      setTimeout(() => window.print(), 1000);
    });
  }

  parseMetrics(data: Object): DashboardMetrics {
    return {
      ...data,
      reachByAgeRange: AgeRangeReaches.parse(data.reachByAgeRange),
      reachByGender: new GenderReach(data.reachByGender.female, data.reachByGender.male),
      reachByRegion: data.reachByRegion ? data.reachByRegion.map(GeolocationReach.parse) : undefined,
      antennaReach: data.antennaReach ? AntennaReach.parse(data.antennaReach) : undefined,
    };
  }

  render() {
    const {
      loaded,
      metricsData,
      from,
      to,
      monthlySelected,
      type,
      radio,
      geoMapType,
      geoMapData,
      centralMarket,
    } = this.state;

    return (
      <PrintingPage loading={!loaded}>
        <Wrapper>
          <PrintingHeader radio={radio} centralMarket={centralMarket} />
          {!monthlySelected &&
          <WeeklyDashboardPrinting
            data={metricsData}
            from={from}
            to={to}
            type={type}
          />}
          {monthlySelected &&
          <MonthlyDashboardPrinting
            data={metricsData}
            from={from}
            to={to}
            type={type}
          />
          }
        </Wrapper>
        <Wrapper>
          {metricsData &&
          <DashboardPrintingDemoGeo
            metrics={metricsData}
            geoMapType={geoMapType}
            geoMapData={geoMapData}
          />
          }
        </Wrapper>
      </PrintingPage>
    );
  }
}

export default DashboardPrintingPage;



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/DashboardPrintingPage.js